import TalLoading from './TalLoading'
import TalToast from './TalToast'


export default {
  install (Vue, options = {}) {
    Vue.use(TalLoading)
    Vue.use(TalToast)
  }
}
